import { colors } from '@styles';
import { flexMixin, textMixin } from '@styles/mixins';
import { css, styled } from 'styled-components';
import { Form, DatePicker } from 'antd';

export const Wrapper = styled.div`
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-width: 360px;
    max-height: 95vh;
    overflow: auto;
    background: #f7f7f7;
    border-radius: 5px;
    z-index: 1000;
    display: flex;
    padding: 40px 30px;
`;
export const CloseBtn = styled.button`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    color: #8f8f8f;
    border: none;
    background: ${colors.white};
    height: 25px;
    ${flexMixin('row', 'center', 'flex-start')}
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 10px;
    margin-right: 10px;
    cursor: pointer;
    &:hover {
        color: #5e5e5e;
    }
`;
export const FormContainer = styled.form`
    padding: 21px 0 0 0;
    height: 80%;
    ${flexMixin('column', 'flex-start', 'center')}
    gap: 10px;
`;

export const WrapSelect = styled.div`
    width: 100%;
    height: 40px;
`;

export const StyledButtonSend = styled.button`
    ${flexMixin('row', 'center', 'center')}
    cursor: pointer;
    height: 40px;
    background: #a7388e;
    border-radius: 5px;
    border: none;
    width: 100%;
    margin-top: 15px;
    & span {
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        text-align: center;
        color: #ffffff;
    }
    &:hover {
        background: #97267d;
    }
`;

export const Label = styled.label`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
`;
export const Input = styled.input<{
    password?: boolean;
    $hasError?: boolean;
}>`
    position: relative;
    width: 100%;
    height: 40px;
    padding: 0 17px 0 18px;
    border-radius: 8px;
    color: #1f1e24;
    border: 1px solid ${props => (props.$hasError ? 'red' : '#D6DCE9')};
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;

    ${({ password }) =>
        password &&
        css`
            width: 156px;
        `}

    &:focus {
        border: 1px solid ${colors.primaryBg};
        outline: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    &:hover {
        border: 1px solid ${colors.primaryBg};
        outline: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    ::placeholder {
        color: #a5a5a5;
    }

    :-ms-input-placeholder {
        color: #a5a5a5;
    }

    ::-ms-input-placeholder {
        color: #a5a5a5;
    }

    &:invalid {
        border: 1px solid red;
    }
`;

export const FormItemContainer = styled.div<{
    password?: boolean;
}>`
    width: 100%;
    ${flexMixin('column', 'flex-start', 'flex-start')}
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};

    ${({ password }) =>
        password &&
        css`
            display: flex;
            gap: 10px;
        `}
`;

export const FormItem = styled(Form.Item)`
    width: 100%;
    && {
        margin-bottom: 0 !important;
    }

    .ant-form-item-control {
        width: 100%;
        max-width: 100%;
    }

    .ant-form-item-explain {
        color: ${colors.error} !important;
        font-size: 10px;
        margin-top: 2px;
        display: block !important;
        opacity: 1 !important;
    }
    .ant-form-item-explain-error {
        display: block !important;
        opacity: 1 !important;
    }
`;

export const StyledDatePicker = styled(DatePicker)`
    width: 100%;
    border: 1px solid ${colors.lightGrey};
    border-radius: 6px;
    padding: 0 9px 0 0;

    .ant-picker-input {
        input {
            color: ${colors.grey};
            ${textMixin({
                fontSize: '14px',
                fontWeight: 400,
            })};
            padding: 0 15px;
            &::placeholder {
                color: ${colors.grey};
                opacity: 1;
                ${textMixin({
                    fontSize: '14px',
                    fontWeight: 400,
                })};
            }
        }
    }

    .ant-picker-suffix {
        color: ${colors.grey} !important;
        cursor: pointer;

        svg {
            fill: ${colors.grey} !important;
            color: ${colors.grey} !important;
            transition:
                fill 0.2s ease,
                color 0.2s ease;
        }

        &:hover {
            color: ${colors.primaryBg} !important;

            svg {
                fill: ${colors.primaryBg} !important;
                color: ${colors.primaryBg} !important;
            }
        }
    }
    .ant-picker-clear {
        color: ${colors.white} !important;
        background: transparent;
        cursor: pointer;

        svg {
            fill: ${colors.grey} !important;
            color: ${colors.grey} !important;
            transition:
                fill 0.2s ease,
                color 0.2s ease;
        }

        &:hover {
            color: ${colors.primaryBg} !important;
            background: transparent !important;

            svg {
                fill: ${colors.primaryBg} !important;
                color: ${colors.primaryBg} !important;
            }
        }
    }

    &:hover .ant-picker-clear {
        opacity: 1;
        color: ${colors.grey} !important;

        &:hover {
            color: ${colors.grey} !important;

            svg {
                fill: ${colors.grey} !important;
                color: ${colors.grey} !important;
            }
        }
    }

    &:hover .ant-picker-suffix {
        color: ${colors.grey} !important;

        svg {
            fill: ${colors.grey} !important;
            color: ${colors.grey} !important;
        }
    }

    &:hover .ant-picker-suffix:hover {
        color: ${colors.primaryBg} !important;

        svg {
            fill: ${colors.primaryBg} !important;
            color: ${colors.primaryBg} !important;
        }
    }

    &.ant-picker-focused .ant-picker-suffix {
        color: ${colors.grey} !important;

        svg {
            fill: ${colors.grey} !important;
            color: ${colors.grey} !important;
        }
    }

    &:hover,
    &:hover .ant-picker-input > input,
    &:hover .ant-picker {
        // color: ${colors.white};
    }

    .ant-picker-panel {
        background-color: black;
        color: white;
    }

    .ant-picker-header {
        background-color: black;
        color: white;
    }

    .ant-picker-super-prev-icon,
    .ant-picker-super-next-icon,
    .ant-picker-prev-icon,
    .ant-picker-next-icon {
        color: white;
    }

    .ant-picker-cell {
        color: white;

        &-disabled {
            color: rgba(255, 255, 255, 0.3);
        }

        &:hover {
            background-color: ${colors.gradStart};
        }
    }

    .ant-picker-cell-today .ant-picker-cell-inner::before {
        border-color: white;
    }

    .ant-picker-cell-selected .ant-picker-cell-inner {
        background-color: ${colors.gradStart};
        color: white;
    }
`;
